
import Anchors from '@scripts/utilities/anchors.js';


/**
 * A wrapper function for logging events to Google Tag Manager.
 * We assume that gtm.js has already been injected, and the dataLayer is
 * available for us to use.
 */
(function(window) {
  var log = function(eventName, properties) {
    if (eventName) {
      if (window.dataLayer) {
        var event = {
          'event': eventName
        };

        if ((typeof properties === 'object') && (properties !== null)) {
          for (var i in properties) {
            if (properties.hasOwnProperty(i)) {
              event[i] = properties[i];
            }
          }
        }

        // finally, log the event
        window.dataLayer.push(event);
      }
    } else {
      console.warn('No eventName parameter passed to CSAnalytics');
    }
  }

  /**
   * A helper function to track clicks on links.
   * Essentially this just adds a slight delay to processing the link click
   * event, to give analytics a chance to "fire".
   * The fourth parameter, `event` is expected to be the click event so that we
   * can manipulate it.
   */
  var logClick = function(eventName, properties, anchor, event) {
    // if the anchor is loading in a new tab, we don't need anything fancy, as
    // our page will remain, and there's plenty of time to record the event.
    if (Anchors.opensInNewTab(anchor)) {
      log(eventName, properties);
    } else {
      // don't "click" the link
      event.preventDefault();

      log(eventName, properties);

      // after a small delay, then "click" the link.
      window.setTimeout(function() {
        window.location.href = anchor.href;
      }, 500);
    }
  };

  window.CSAnalytics = log;
  window.CSAnalyticsClick = logClick;
})(window);


// import other components used to track analytics events
import './analytics/back-end-events.js';
import './analytics/external-links.js';
import './analytics/learn-dash.js';
import './analytics/video-embeds.js';

